// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo_logoContainer__3YZnM {\n  width: 70px;\n  -webkit-user-select: none;\n          user-select: none; }\n  .logo_logoContainer__3YZnM .logo_root__p98_e {\n    width: 70px;\n    height: auto;\n    margin-top: 10px;\n    margin-bottom: 44px;\n    margin-left: 7px;\n    cursor: pointer; }\n", ""]);
// Exports
exports.locals = {
	"logoContainer": "logo_logoContainer__3YZnM",
	"root": "logo_root__p98_e"
};
module.exports = exports;
